module.exports = __webpack_public_path__ + "static/media/24-hours.82c00779.png";